import React from 'react';
import PropTypes from 'prop-types';

import {
  CuiPanel,
  CuiButton,
  CuiRhythm,
  CuiTextBlock,
  CuiCtaGem,
} from '../../components';

export const BuyCallToAction = ({ className, ...rest }) => (
  <CuiPanel padding="l" color="highlight" className={className} {...rest}>
    <div className="buyCallToAction">
      <CuiCtaGem
        color="highlight"
        className="buyCallToActionGem"
        classNameArt="buyCallToActionGem__art"
      />
      <div>
        <CuiRhythm size="s">
          <CuiTextBlock>
            <h3>Level up your React skills the easy way</h3>

            <h4>
              React, Redux, webpack, Sass, and more &mdash; all in one project!{' '}
              <strong>Boost your career as a front-end engineer.</strong>
            </h4>
          </CuiTextBlock>
        </CuiRhythm>

        <CuiButton
          isFullWidth
          color="highlight"
          href="http://buy.flexboxpatterns.com"
        >
          Learn more
        </CuiButton>
      </div>
    </div>
  </CuiPanel>
);

BuyCallToAction.propTypes = {
  className: PropTypes.string,
};

BuyCallToAction.defaultProps = {
  className: undefined,
};



// WEBPACK FOOTER //
// ./ui/partials/buyCallToAction/BuyCallToAction.js